var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c(
        "v-dialog",
        {
          attrs: {
            name: "basic-t",
            title: _vm.dialogTitle,
            "close-on-click-modal": _vm.closeOnClickModal1,
            modal: true,
            width: 80,
            height: 30,
            confirmButtonText: _vm.suredown,
            "append-to-body": "",
          },
          on: {
            confirm: _vm.handleConfirm,
            "after-close": _vm.handleAfterClose,
          },
          model: {
            value: _vm.isShow,
            callback: function ($$v) {
              _vm.isShow = $$v
            },
            expression: "isShow",
          },
        },
        [
          _c(
            "v-form",
            { ref: "form", attrs: { model: _vm.ruleForm, rules: _vm.rules } },
            [
              _c(
                "v-form-item",
                { staticClass: "newlag", attrs: { prop: "change_log" } },
                [
                  _c(
                    "template",
                    { staticClass: "newlag-left", slot: "label" },
                    [
                      _c("span", { staticClass: "required" }),
                      _c("span", [_vm._v("添加新语言")]),
                    ]
                  ),
                  _c("v-radio", {
                    attrs: { name: "radio", options: _vm.languageOptions },
                    model: {
                      value: _vm.ruleForm.newlanguage,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "newlanguage", $$v)
                      },
                      expression: "ruleForm.newlanguage",
                    },
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }